<div class="hub-input">
    <label
        *ngIf="!hideLabel"
        [for]="id"
        class="emd-label"
        [ngClass]="{
            _state_error: control.touched && control.invalid,
        }"
        >{{ label }}<i *ngIf="isRequired"> *</i></label
    >
    <div class="emd-select" [ngClass]="{ _state_error: control.touched && control.invalid }">
        <select
            type="text"
            [(ngModel)]="value"
            [disabled]="isReadOnly"
            (blur)="onTouched()"
            (change)="onChanged(value)"
            [attr.data-cy]="controlName"
        >
            <option *ngIf="useDefaultOption" [value]="null" disabled hidden>Selecione</option>
            <option *ngFor="let item of data" [value]="item.id">
                {{ item.name }}
            </option>
        </select>
        <div class="emd-select__arrow"></div>
    </div>
</div>
